<script>
import Banner from '../components/banner';
export default {
    name: "home",
    data() {
        return {
            
        };
    },
    computed: {},
    components: {
        Banner
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="home">
        <Banner type="home" position="bottom" :image="require('@/assets/images/home_banner.jpg')" :title="`Your Gateway\r\nto British\r\nEducation`"/>
        <div class="wrapper layout_main">
            <div class="title">Oxbridge Academy London</div>
            <div class="title mobile">Oxbridge<br/>Academy London</div>
            <div class="desc">OxbridgeAcademyLondon is an innovative private higher education organization, accredited and<br/>collaborating with top British universities and professional institutions worldwide</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.home{
    .wrapper{
        padding: .7rem 0;
        text-align: center;
        .title{
            font-size: .6rem;
            font-weight: 600;
            color: #12294b;
            margin-bottom: .7rem;
            &.mobile{
                display: none;
            }
            @media only screen and (max-width: 750px) {
                font-size: .48rem;
                font-weight: bold;
                display: none;
                &.mobile{
                    display: block;
                }
            }
        }
        .desc{
            font-size: .16rem;
            font-weight: normal;
            color: #666;
            letter-spacing: .16em;
            line-height: 2;
            @media only screen and (max-width: 750px) {
                font-size: .24rem;
                letter-spacing: .05em;
                padding: 0 .6rem;
            }
        }
    }
}
</style>